import { createAsyncThunk } from '@reduxjs/toolkit';
import { notification } from 'antd';
import * as API from '../api/index.js';

export const fetchServerDate = createAsyncThunk('debug/fetchServerDate', async (_, { rejectWithValue }) => {
    try {
        const { date } = await API.date.get();
        return date;
    } catch (e) {
        notification.error({ message: 'Error', description: e.message || 'Server error' });
        return rejectWithValue(e.message);
    }
});

export const resetServerDate = createAsyncThunk('debug/resetServerDate', async (_, { rejectWithValue }) => {
    try {
        const { message } = await API.date.reset();
        notification.info({
            message,
            description: `Please refresh this page and change date on PC`,
        });
        return true;
    } catch (e) {
        notification.error({ message: 'Error', description: e.message || 'Server error' });
        return rejectWithValue(e.message);
    }
});

export const changeServerDate = createAsyncThunk(
    'debug/changeServerDate',
    async ({ data }, { dispatch, rejectWithValue }) => {
        try {
            const { endDay, id, status } = await API.date.change(data);

            if (status) {
                dispatch(getTimeRewind(id));
            } else {
                notification.info({
                    message: 'Change Date',
                    description: `Please change the date to ${endDay} on your PC`,
                });
            }

            return { serverDate: endDay, rewindId: id, status };
        } catch (e) {
            notification.error({ message: 'Error', description: e.message || 'Server error' });
            return rejectWithValue(e.message);
        }
    },
);

export const getTimeRewind = createAsyncThunk('debug/getTimeRewind', async ({ id }, { dispatch, rejectWithValue }) => {
    try {
        await new Promise((resolve) => setTimeout(resolve, 2000));
        const { status, endDay } = await API.date.getRewind(id);

        if (status) {
            dispatch(getTimeRewind(id));
            return { serverDate: endDay, rewindId: id, status };
        }
        notification.info({
            message: 'Change Date',
            description: `Done! Please change the date to ${endDay} on your PC`,
        });

        return { serverDate: endDay, rewindId: id, status };
    } catch (e) {
        notification.error({ message: 'Error', description: e.message || 'Server error' });
        return rejectWithValue(e.message);
    }
});

export const fetchEmails = createAsyncThunk('debug/fetchEmails', async ({ page }, { getState, rejectWithValue }) => {
    try {
        const perPage = getState().general.settings.perPage;
        const emails = await API.date.getEmails(page, perPage);
        return emails;
    } catch (e) {
        notification.error({ message: 'Error', description: e.message || 'Server error' });
        return rejectWithValue(e.message);
    }
});
